import _ from 'lodash';


export default function ObserverService() {
  const service = this;

  // private
  const subscription = {};

  // public function
  service.subscribe = subscribe;
  service.unsubscribeAll = unsubscribeAll;
  service.publish = publish;
  service.publishAll = publishAll;
  service.isListening = isListening;
  service.unsubscribe = unsubscribe;

  function subscribe(eventName, id, func) {
    subscription[eventName] = subscription[eventName] || {};
    subscription[eventName][id] = subscription[eventName][id] || [];
    subscription[eventName][id].push(func);
  }

  function unsubscribe(eventName, id) {
    if (_.has(subscription, [eventName, id])) {
      delete subscription[eventName][id];
      if (_.isEmpty(subscription[eventName])) {
        delete subscription[eventName];
      }
    } else {
      console.error('could not destroy:', eventName, id);
    }
  }

  function unsubscribeAll(eventName) {
    delete subscription[eventName];
  }

  function publish(eventName, id, data) {
    _.forEach(_.get(subscription, [eventName, id], []), func => func(data));
  }

  function publishAll(eventName, data) {
    _.forEach(_.keys(subscription[eventName]), id => publish(eventName, id, data));
  }

  function isListening(eventName, id) {
    return Boolean(_.get(subscription, [eventName, id, 'length'], false));
  }
}
